import { Head } from "@inertiajs/react"
import Navbar from "@/components/chalky_booking/Navbar"
import Hero from "@/components/chalky_booking/Hero"
import Services from "@/components/chalky_booking/Services"
import About from "@/components/chalky_booking/About"
import ContactForm from "@/components/chalky_booking/ContactForm"
import Footer from "@/components/chalky_booking/Footer"

interface ServiceMedia {
  type: "image" | "video"
  src: string
  poster?: string
  credit?: string
  alt?: string
}

interface ServiceCard {
  key: "touring" | "concerts" | "studio" | "screen_printing"
  title: string
  description: string
  media: ServiceMedia
}

interface HomeProps {
  meta: {
    title: string
    description: string
    image: string
  }
  brand: { line1: string; line2: string }
  nav: { services: string; agency: string; contact: string }
  hero: {
    title_line1: string
    title_line2: string
    tagline: string
    cta_contact: string
    cta_services: string
  }
  services: {
    title: string
    subtitle: string
    learn_more: string
    cards: ServiceCard[]
  }
  about: { title: string; description1: string; description2: string }
  contact: {
    title: string
    subtitle: string
    form: {
      name: string
      name_placeholder: string
      email: string
      email_placeholder: string
      message: string
      message_placeholder: string
      submit: string
    }
  }
  footer: {
    description: string
    navigation: string
    contact: string
    copyright: string
    legal: string
    privacy: string
  }
  contact_email: string
  paths: { mentions_legales: string; confidentiality: string }
  locales: string[]
  current_locale: string
  language_labels: Record<string, string>
}

export default function Home({
  meta,
  brand,
  nav,
  hero,
  services,
  about,
  contact,
  footer,
  contact_email,
  paths,
  locales,
  current_locale,
  language_labels,
}: HomeProps) {
  return (
    <>
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:type" content="website" />
      </Head>

      <Navbar
        brand={brand}
        nav={nav}
        locales={locales}
        currentLocale={current_locale}
        languageLabels={language_labels}
      />
      <main>
        <Hero {...hero} />
        <Services {...services} />
        <About {...about} />
        <ContactForm
          title={contact.title}
          subtitle={contact.subtitle}
          labels={contact.form}
        />
      </main>
      <Footer
        brand={brand}
        nav={nav}
        footer={footer}
        contactEmail={contact_email}
        paths={{
          mentionsLegales: paths.mentions_legales,
          confidentiality: paths.confidentiality,
        }}
      />
    </>
  )
}
